/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
/**
@prop --ux-stepper-gap-size: spacing between input and stepper buttons
@prop --ux-stepper-button-bg-color: background-color of the stepper buttons
@prop --ux-stepper-button-focus-bg-color: background-color of the stepper buttons when focussed
@prop --ux-stepper-button-hover-text-color: text color of the stepper buttons when hovered
@prop --ux-stepper-button-shadow: box-shadow of the stepper buttons
 */
.ux-stepper {
  box-sizing: border-box;
  display: block;
  margin: 0;
  max-width: 100%;
  position: relative;
}
.ux-stepper .ux-input-field-number__buttons {
  margin-left: var(--ux-stepper-gap-size);
}
.ux-stepper ux-button:not([disabled]) {
  z-index: 1;
}
.ux-stepper ux-button:hover,
.ux-stepper ux-button:active,
.ux-stepper ux-button:focus {
  z-index: 2;
}
.ux-stepper__decrease, .ux-stepper__increase {
  --ux-button-shadow: var(--ux-stepper-button-shadow);
  --ux-button-bg-color: var(--ux-stepper-button-bg-color);
  --ux-button-disabled-bg-color: var(--ux-stepper-button-bg-color);
  --ux-button-hover-bg-color: var(--ux-stepper-button-bg-color);
  --ux-button-focus-bg-color: var(--ux-stepper-button-focus-bg-color);
  --ux-button-hover-text-color: var(--ux-stepper-button-hover-text-color);
  padding: 0;
}
.ux-stepper__decrease .ux-button, .ux-stepper__increase .ux-button {
  height: 100%;
  min-height: 0;
  padding: 0;
}
.ux-stepper__decrease {
  margin-right: -1px;
}